export default {
  ZipCodeFormField__ARIA: "zip code",
  ZipCodeFormField__LABEL: "ZIP/Postal code",
};
